<template>
	<div v-if="resource.links.length > 3" class="w-full lg:w-fit place-self-start lg:place-self-auto flex items-center gap-2 overflow-x-auto">
		<template v-for="(link, linkIndex) in resource.links" :key="`link-${linkIndex}`">
			<button type="button" :class="`px-2 py-1 rounded-lg ${link.url ? (link.active ? 'bg-gray-100 dark:bg-gray-800' : 'hover:bg-gray-100 dark:hover:bg-gray-800') : 'text-gray-400 dark:text-gray-600'}`" @click.stop="changePage(link)">
				{{ link.label }}
			</button>
		</template>
	</div>
</template>
<script setup lang="ts">
import {router} from '@inertiajs/vue3'
import {type Model} from '@/Types/Model'
import {defineEmits, defineProps, ref, type Ref} from 'vue'
import {type PaginatedLink} from '@/Types/System/Pagination/PaginatedLink'
import {type PaginatedResult} from '@/Types/System/Pagination/PaginatedResult'

const props = defineProps<{
	emitLink?:boolean,
	resource:PaginatedResult<Model>,
}>()

const emit = defineEmits([
	'redirect',
])

const emitLink:Ref<boolean> = ref(props.emitLink ?? false)
const resource:Ref<PaginatedResult<Model>> = ref(props.resource)

function changePage(link:PaginatedLink):void{
	if(link.url){
		if(emitLink.value){
			emit('redirect', link.url)
		} else {
			router.get(link.url)
		}
	}
}
</script>
